import { useTranslation } from 'react-i18next'

// Matches the prototype's page-level `.pg-act.save`/`.pg-act.discard` pair
// (e.g. `excess-save-btn`/`excess-discard-btn`: 6px padding round an 18px
// glyph, 6px radius, no gap, an accent-subtle / danger-bg hover) — a
// Save/Discard action beside the page header (PageHeader's `actions`), inert
// until the page has an unsaved draft. Shared by
// any page whose settings are edited as a draft and committed as a batch,
// rather than autosaved field-by-field. `busy` (a save in flight) holds both
// inert too, so a second click cannot start a second save.
export function PageSaveDiscard({
  dirty,
  busy = false,
  onSave,
  onDiscard,
}: Readonly<{
  dirty: boolean
  busy?: boolean
  onSave: () => void
  onDiscard: () => void
}>) {
  const { t } = useTranslation()
  const inert = !dirty || busy
  return (
    <div className="flex items-center" aria-busy={busy || undefined}>
      <button
        type="button"
        disabled={inert}
        onClick={onSave}
        title={t('common.save')}
        aria-label={t('common.save')}
        className="p-1.5 inline-flex items-center rounded-md transition-[opacity,background-color] disabled:opacity-30 disabled:pointer-events-none hover:bg-[var(--accent-subtle)]"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" stroke="var(--accent)" fill="none" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </button>
      <button
        type="button"
        disabled={inert}
        onClick={onDiscard}
        title={t('common.discard')}
        aria-label={t('common.discard')}
        className="p-1.5 inline-flex items-center rounded-md transition-[opacity,background-color] disabled:opacity-30 disabled:pointer-events-none hover:bg-[var(--danger-bg)]"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" stroke="var(--danger)" fill="none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  )
}
